import type { MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getPeople } from '@/features/profile/api/people'
import type { Person } from '@/types/people'

/** `enabled` — T-133: the search's «Personalized for» asks only for a signed-in user. */
export const usePeopleQuery = (enabled?: MaybeRef<boolean>) => {
  return createQuery<Person[]>({
    key: ['people'],
    fetcher: getPeople,
    enabled,
  })
}
